(function() {
    // Prevent duplicate injection
    if (document.querySelector('.spaceman-sticky-bar')) return;


    // ===================
    // CSS STYLES
    // ===================
    var css = `
        .spaceman-sticky-bar *,
        .spaceman-sticky-bar *::before,
        .spaceman-sticky-bar *::after {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
        }


        .spaceman-sticky-bar {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 999999;
            background: #fff;
            border-top: 1px solid rgba(0, 0, 0, 0.08);
            font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, sans-serif;
            transform: translateY(100%);
            animation: spaceman-slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
            animation-delay: 1s;
        }


        @keyframes spaceman-slideUp {
            to { transform: translateY(0); }
        }


        @keyframes spaceman-shimmer {
            0% { left: -100%; }
            50%, 100% { left: 100%; }
        }


        .spaceman-sticky-bar__inner {
            display: flex;
            align-items: stretch;
            justify-content: center;
            max-width: 100%;
            height: 54px;
        }


        .spaceman-sticky-bar__item {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            height: 100%;
            text-decoration: none;
            font-size: 10px;
            font-weight: 500;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            transition: all 0.25s ease;
            cursor: pointer;
            border: none;
            outline: none;
        }


        .spaceman-sticky-bar__item:not(:last-child) {
            border-right: 1px solid rgba(0, 0, 0, 0.06);
        }


        .spaceman-sticky-bar__icon {
            width: 16px;
            height: 16px;
            flex-shrink: 0;
            opacity: 0.85;
        }


        .spaceman-sticky-bar__text {
            white-space: nowrap;
        }


        .spaceman-sticky-bar__text--short {
            display: none;
        }


        .spaceman-sticky-bar__text--full {
            display: inline;
        }


        /* Book Appointment - Primary CTA with shimmer */
        .spaceman-sticky-bar__item--book {
            background: #000;
            color: #fff;
            flex: 1.2;
            position: relative;
            overflow: hidden;
        }


        .spaceman-sticky-bar__item--book::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent);
            animation: spaceman-shimmer 3s ease-in-out infinite;
            animation-delay: 2s;
        }


        .spaceman-sticky-bar__item--book:hover {
            background: #1a1a1a;
        }


        .spaceman-sticky-bar__item--book:hover::before {
            animation: none;
            opacity: 0;
        }


        .spaceman-sticky-bar__item--book .spaceman-sticky-bar__icon {
            opacity: 1;
        }


        /* Contact (Call/Email) */
        .spaceman-sticky-bar__item--contact {
            background: #fff;
            color: #333;
        }


        .spaceman-sticky-bar__item--contact:hover {
            background: #fafafa;
            color: #000;
        }


        .spaceman-sticky-bar__item--contact .spaceman-sticky-bar__icon {
            color: #333;
        }


        /* WhatsApp */
        .spaceman-sticky-bar__item--whatsapp {
            background: #fff;
            color: #333;
        }


        .spaceman-sticky-bar__item--whatsapp:hover {
            background: #fafafa;
            color: #25D366;
        }


        .spaceman-sticky-bar__item--whatsapp .spaceman-sticky-bar__icon {
            color: #25D366;
        }


        /* Maps */
        .spaceman-sticky-bar__item--maps {
            background: #fff;
            color: #333;
            display: none;
        }


        .spaceman-sticky-bar__item--maps:hover {
            background: #fafafa;
            color: #4285F4;
        }


        .spaceman-sticky-bar__item--maps .spaceman-sticky-bar__icon {
            color: #EA4335;
        }


        /* Hide live chat widget on desktop */
        @media (min-width: 768px) {
            .o-livechat-root {
                display: none !important;
            }
        }


        /* Hide WhatsApp floating widget */
        #wa-chat-btn-root {
            display: none !important;
        }


        /* Reviews Section */
        .spaceman-sticky-bar__reviews {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
            padding: 0 12px;
            height: 100%;
            background: #fff;
            border-right: 1px solid rgba(0, 0, 0, 0.06);
            flex-shrink: 0;
        }


        .spaceman-sticky-bar__stars {
            display: flex;
            align-items: center;
            gap: 1px;
        }


        .spaceman-sticky-bar__star {
            width: 12px;
            height: 12px;
            color: #00b67a;
        }


        .spaceman-sticky-bar__rating {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-left: 3px;
        }


        .spaceman-sticky-bar__rating-score {
            font-size: 12px;
            font-weight: 700;
            color: #000;
            line-height: 1;
            letter-spacing: -0.02em;
        }


        .spaceman-sticky-bar__rating-count {
            font-size: 8px;
            font-weight: 500;
            color: #777;
            line-height: 1.2;
            text-transform: none;
        }


        /* Mobile: shorter text labels */
        @media (max-width: 479px) {
            .spaceman-sticky-bar__item--contact .spaceman-sticky-bar__text,
            .spaceman-sticky-bar__item--whatsapp .spaceman-sticky-bar__text {
                display: none;
            }


            .spaceman-sticky-bar__item--contact,
            .spaceman-sticky-bar__item--whatsapp {
                flex: 0 0 50px;
            }


            .spaceman-sticky-bar__item--book {
                flex: 1;
            }


            .spaceman-sticky-bar__text--full {
                display: none;
            }


            .spaceman-sticky-bar__text--short {
                display: inline;
            }


            .spaceman-sticky-bar__reviews {
                flex: 0 0 auto;
                padding: 0 8px;
            }
        }


        /* Focus states */
        .spaceman-sticky-bar__item:focus-visible {
            outline: 2px solid #000;
            outline-offset: -2px;
        }


        /* Tablet & Desktop */
        @media (min-width: 768px) {
            .spaceman-sticky-bar__inner {
                max-width: 900px;
                margin: 0 auto;
                height: 52px;
            }


            .spaceman-sticky-bar__item {
                font-size: 11px;
                letter-spacing: 0.1em;
                gap: 8px;
            }


            .spaceman-sticky-bar__icon {
                width: 18px;
                height: 18px;
            }


            .spaceman-sticky-bar__reviews {
                padding: 0 20px;
                gap: 6px;
            }


            .spaceman-sticky-bar__star {
                width: 14px;
                height: 14px;
            }


            .spaceman-sticky-bar__rating-score {
                font-size: 14px;
            }


            .spaceman-sticky-bar__rating-count {
                font-size: 9px;
            }
        }


        /* Large Desktop */
        @media (min-width: 1024px) {
            .spaceman-sticky-bar__inner {
                max-width: 1000px;
                height: 54px;
            }


            .spaceman-sticky-bar__star {
                width: 15px;
                height: 15px;
            }


            .spaceman-sticky-bar__reviews {
                padding: 0 24px;
            }
        }


        /* Small Mobile */
        @media (max-width: 374px) {
            .spaceman-sticky-bar__inner {
                height: 50px;
            }


            .spaceman-sticky-bar__item {
                font-size: 9px;
            }


            .spaceman-sticky-bar__item--contact,
            .spaceman-sticky-bar__item--whatsapp {
                flex: 0 0 44px;
            }


            .spaceman-sticky-bar__icon {
                width: 15px;
                height: 15px;
            }


            .spaceman-sticky-bar__reviews {
                padding: 0 6px;
            }


            .spaceman-sticky-bar__star {
                width: 10px;
                height: 10px;
            }


            .spaceman-sticky-bar__rating-score {
                font-size: 11px;
            }


            .spaceman-sticky-bar__rating-count {
                font-size: 7px;
            }
        }


        /* iOS Safe Area */
        @supports (padding-bottom: env(safe-area-inset-bottom)) {
            .spaceman-sticky-bar {
                padding-bottom: env(safe-area-inset-bottom);
            }
        }


        /* Reduced motion preference */
        @media (prefers-reduced-motion: reduce) {
            .spaceman-sticky-bar {
                animation: none;
                transform: translateY(0);
            }


            .spaceman-sticky-bar__item--book::before {
                animation: none;
            }


            .spaceman-sticky-bar__item,
            .spaceman-sticky-bar__icon {
                transition: none;
            }
        }


        /* Print - hide sticky bar */
        @media print {
            .spaceman-sticky-bar {
                display: none !important;
            }
        }
    `;


    var style = document.createElement('style');
    style.id = 'spaceman-sticky-bar-style';
    style.textContent = css;
    document.head.appendChild(style);


    // ===================
    // HTML STRUCTURE
    // ===================
    var starSvg = '<svg class="spaceman-sticky-bar__star" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
    var partialStar = '<svg class="spaceman-sticky-bar__star" viewBox="0 0 24 24" fill="currentColor"><defs><linearGradient id="spaceman-star-grad"><stop offset="80%" stop-color="#00b67a"/><stop offset="80%" stop-color="#ddd"/></linearGradient></defs><path fill="url(#spaceman-star-grad)" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';


    var nav = document.createElement('nav');
    nav.className = 'spaceman-sticky-bar';
    nav.setAttribute('role', 'navigation');
    nav.setAttribute('aria-label', 'Quick contact options');


    nav.innerHTML = `
        <div class="spaceman-sticky-bar__inner">
            <!-- Reviews Badge -->
            <div class="spaceman-sticky-bar__reviews" aria-label="4.8 out of 5 stars from 264 reviews">
                <div class="spaceman-sticky-bar__stars">
                    ${starSvg}${starSvg}${starSvg}${starSvg}${partialStar}
                </div>
                <div class="spaceman-sticky-bar__rating">
                    <span class="spaceman-sticky-bar__rating-score">4.8</span>
                    <span class="spaceman-sticky-bar__rating-count">264+ reviews</span>
                </div>
            </div>


            <!-- Book Appointment (Primary CTA) -->
            <a href="/pages/appointments" class="spaceman-sticky-bar__item spaceman-sticky-bar__item--book" aria-label="Book an appointment">
                <svg class="spaceman-sticky-bar__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <span class="spaceman-sticky-bar__text spaceman-sticky-bar__text--full">Book Appointment</span>
                <span class="spaceman-sticky-bar__text spaceman-sticky-bar__text--short">Book</span>
            </a>


            <!-- Contact Button (Call during business hours, Email outside) -->
            <a id="spaceman-contact-btn" href="tel:+6565272271" class="spaceman-sticky-bar__item spaceman-sticky-bar__item--contact" aria-label="Call us">
                <svg class="spaceman-sticky-bar__icon" id="spaceman-contact-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <span class="spaceman-sticky-bar__text" id="spaceman-contact-text">Call Us</span>
            </a>


            <!-- WhatsApp -->
            <a id="spaceman-whatsapp-btn" href="https://wa.me/6587843680" class="spaceman-sticky-bar__item spaceman-sticky-bar__item--whatsapp" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp us">
                <svg class="spaceman-sticky-bar__icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <span class="spaceman-sticky-bar__text">WhatsApp</span>
            </a>
        </div>
    `;


    document.body.appendChild(nav);


    // ===================
    // BUSINESS HOURS LOGIC
    // ===================
    function isBusinessHours() {
        var now = new Date();
        var sgTime = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }));
        var hour = sgTime.getHours();
        return hour >= 10 && hour < 19;
    }


    function getMailtoLink() {
        var subject = encodeURIComponent('Enquiry from Spaceman Website');
        var pageTitle = document.title || 'Spaceman';
        var pageUrl = window.location.href;
        var body = encodeURIComponent('Hi Spaceman,\n\nI was browsing your website and had a question.\n\n---\nPage: ' + pageTitle + '\nURL: ' + pageUrl);
        return 'mailto:store@spaceman.com?subject=' + subject + '&body=' + body;
    }


    function updateContactButton() {
        var btn = document.getElementById('spaceman-contact-btn');
        var icon = document.getElementById('spaceman-contact-icon');
        var text = document.getElementById('spaceman-contact-text');


        if (!btn || !icon || !text) return;


        if (isBusinessHours()) {
            // During business hours: Show Call Us
            btn.href = 'tel:+6565272271';
            btn.setAttribute('aria-label', 'Call us');
            text.textContent = 'Call Us';
            icon.innerHTML = '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>';
        } else {
            // Outside business hours: Show Email Us with pre-filled content
            btn.href = getMailtoLink();
            btn.setAttribute('aria-label', 'Email us');
            text.textContent = 'Email Us';
            icon.innerHTML = '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>';
        }
    }


    // Run on load
    updateContactButton();


    // Update every minute in case user has page open during transition
    setInterval(updateContactButton, 60000);


    // ===================
    // HIDE BOOK BUTTON ON APPOINTMENTS PAGE
    // ===================
    var bookBtn = document.querySelector('.spaceman-sticky-bar__item--book');
    var sbPath = window.location.pathname.toLowerCase();
    if (bookBtn && (sbPath === '/pages/appointments' || sbPath.indexOf('landing') !== -1)) {
        bookBtn.style.display = 'none';
    }


    // ===================
    // GA4 EVENT TRACKING (direct to GA4 via gtag)
    // ===================
    var GA4_MEASUREMENT_ID = 'G-CKVNE7M9MZ';


    function trackGA4Event(eventName, params) {
        if (typeof gtag === 'function') {
            gtag('event', eventName, Object.assign({ send_to: GA4_MEASUREMENT_ID }, params));
            return true;
        }
        return false;
    }


    // Book Appointment click - delay navigation to ensure tracking fires
    if (bookBtn) {
        bookBtn.addEventListener('click', function(e) {
            var href = this.href;
            e.preventDefault();
            trackGA4Event('stickybar_book', {
                link_url: href,
                page_path: window.location.pathname
            });
            setTimeout(function() {
                window.location.href = href;
            }, 150);
        });
    }


    // Contact (Call/Email) click
    var contactBtn = document.getElementById('spaceman-contact-btn');
    if (contactBtn) {
        contactBtn.addEventListener('click', function() {
            var eventName = isBusinessHours() ? 'stickybar_call' : 'stickybar_email';
            trackGA4Event(eventName, {
                link_url: this.href,
                page_path: window.location.pathname
            });
        });
    }


    // WhatsApp click
    var whatsappBtn = document.getElementById('spaceman-whatsapp-btn');
    if (whatsappBtn) {
        whatsappBtn.addEventListener('click', function() {
            trackGA4Event('stickybar_whatsapp', {
                link_url: this.href,
                page_path: window.location.pathname
            });
        });
    }


})();
